import {match} from 'ts-pattern';

import {useGetUserStatsQuery} from '@dms/api/customer';

import {SourcingUserList} from '../types/SourcingUserList';
import {SourcingType, useSourcingType} from './useSourcingType';

/**
 * How many vehicles the user's list holds for the sourcing type of the current route. Read from
 * the user stats rather than the loaded rows: a list page loads at most one page of rows, so
 * only the stats can tell that a list is over the export limit.
 */
export function useSourcingUserListCount(list: SourcingUserList) {
  const sourcingType = useSourcingType();
  const {data: userStats} = useGetUserStatsQuery();

  const stats =
    sourcingType === SourcingType.AUCTIONS ? userStats?.userAuctionStats : userStats?.userStats;

  return (
    match(list)
      .with('TO_BUY', () => stats?.toBuyCount)
      .with('FAVOURITE', () => stats?.favouriteCount)
      .with('COMPARISON', () => stats?.comparisonCount)
      .with('HIDDEN', () => stats?.hiddenCount)
      .with('CARVAGO_BUY', () => stats?.carvagoBuyCount)
      .exhaustive() ?? 0
  );
}
